module.exports = "/src/views/player/help/images/mask2.jpg";